import React from 'react';
import Avatar, { AvatarProps } from '@mui/material/Avatar';
import { SxStyle } from '../../types';

interface Props extends AvatarProps {
  srcImage?: string;
  fullName?: string;
  size?: 'large' | 'default';
  showTransparency?: boolean;
}

const styles: SxStyle = {
  large: {
    width: '120px',
    height: '120px',
    fontSize: '48px',
  },
  transparentBg: {
    'background-image':
      'linear-gradient(45deg, #ccc 25%, transparent 25%), linear-gradient(-45deg, #ccc 25%, transparent 25%), linear-gradient(45deg, transparent 75%, #ccc 75%), linear-gradient(-45deg, transparent 75%, #ccc 75%)',
    'background-size': '20px 20px',
    'background-position': '0 0, 0 10px, 10px -10px, -10px 0px',
  },
};

function PlayerAvatar({ srcImage, fullName, size = 'default', variant, showTransparency }: Props) {
  const combinedStyles = {
    ...(size === 'large' ? styles.large : {}),
    ...(showTransparency ? styles.transparentBg : {}),
  };
  return <Avatar variant={variant} sx={combinedStyles} alt={fullName} src={srcImage} />;
}

export default PlayerAvatar;
